import React from 'react';
import { EquipmentImage } from '../../../../model/equipment-image';
import { entityManagerProvider } from '../../../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { projectStorage } from '../../../../../firebase/Config';
// import { Upload } from '@progress/kendo-react-upload';
interface EquipmentImageList {
  equipmentImage: EquipmentImage[];
  selected: EquipmentImage;
  ids: number;
  loading: boolean;
  allowAdd: boolean;
  attFile: any;
}

class EquipmentImages extends React.Component<any, EquipmentImageList> {
  manager: EntityManager;
  conditions: String[];
  constructor(props) {
    super(props);
    this.state = {
      equipmentImage: [] as EquipmentImage[],
      selected: null as EquipmentImage,
      ids: 0 as number,
      loading: true,
      allowAdd: true,
      attFile: null,
    };
    this.manager = entityManagerProvider.newManager();
    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addEquipmentImage = this.addEquipmentImage.bind(this);
    this.remove = this.remove.bind(this);
    this.setTypeState = this.setTypeState.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.conditions = ['.img', '.jpg', '.jepg'];
  }

  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('EquipmentImages').where(
      'equipmentId',
      'equals',
      this.props.currentProductId
    );
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        equipmentImage: qr.results,
        loading: false,
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }

  addEquipmentImage() {
    this.setState({
      ids: this.state.ids - 1,
      allowAdd: false,
    });
    let equipmentImage = this.manager.createEntity(
      EquipmentImage.prototype.entityType,
      {
        equipmentImageId: this.state.ids,
        equipmentId: this.props.currentProductId,
      }
    ) as EquipmentImage;
    // select the new customer, and add it to the list of customers
    this.setState({
      selected: equipmentImage,
      equipmentImage: this.state.equipmentImage.concat([equipmentImage]),
    });
  }

  remove(ent: EquipmentImage) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    if (this.state.attFile) {
      const uploadPath = `equipmentimages/${this.props.currentProductId}/${this.state.attFile.name}`;
      projectStorage
        .ref(uploadPath)
        .put(this.state.attFile)
        .then((res) => {
          res.ref.getDownloadURL().then((attUrl) => {
            let selectedEquipment = this.state.selected;
            selectedEquipment.imageUrl = attUrl;
            this.setState({
              selected: selectedEquipment,
            });
            this.manager
              .saveChanges()
              .then(() => {
                // refresh customer list to remove deleted customers
                this.setState({
                  selected: null,
                  equipmentImage: this.manager.getEntities(
                    'EquipmentImage'
                  ) as EquipmentImage[],
                });
              })
              .catch((error) => {
                this.setState({
                  selected: null,
                  equipmentImage: this.manager.getEntities(
                    'EquipmentImage'
                  ) as EquipmentImage[],
                });
                console.log('error catch', error, error.entityErrors);
              })
              .finally(() => {
                this.setState({
                  loading: false,
                  selected: null,
                  allowAdd: true,
                });
              });
          });
        });
    } else {
      this.manager
        .saveChanges()
        .then(() => {
          // refresh customer list to remove deleted customers
          this.setState({
            selected: null,
            equipmentImage: this.manager.getEntities(
              'EquipmentImage'
            ) as EquipmentImage[],
          });
        })
        .catch((error) => {
          this.setState({
            selected: null,
            equipmentImage: this.manager.getEntities(
              'EquipmentImage'
            ) as EquipmentImage[],
          });
          console.log('error catch', error, error.entityErrors);
        })
        .finally(() => {
          this.setState({
            loading: false,
            selected: null,
            allowAdd: true,
          });
        });
    }
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
    let productAtts = this.manager.getEntities(
      'EquipmentImage'
    ) as EquipmentImage[];
    productAtts = productAtts.sort(
      (a, b) => a.equipmentImageId - b.equipmentImageId
    );
    this.setState({
      selected: null,
      equipmentImage: productAtts,
      allowAdd: true,
    });
  }
  handleFileChange(event, equipmentImage) {
    equipmentImage.attachmentUrl = null;
    this.setState({
      attFile: null,
    });
    let selectedFile = event.target.files[0];
    if (selectedFile) {
      this.setState({
        attFile: selectedFile,
      });
    }
  }
  renderPaymentEdit() {
    let equipmentImage = this.state.selected;

    if (equipmentImage) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, equipmentImage)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <form>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <label>Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="imageName"
                      value={equipmentImage.imageName || ''}
                      onChange={equipmentImage.handleChange}
                    />
                  </div>

                  <div className="col-lg-12">
                    <label>Attachment</label>
                    <input
                      className="form-control"
                      type="file"
                      onChange={(e) => this.handleFileChange(e, equipmentImage)}
                    />
                    {equipmentImage.imageUrl && (
                      <>
                        <a
                          href={equipmentImage.imageUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={equipmentImage.imageUrl}
                            alt={equipmentImage.imageName}
                            style={{ maxHeight: '200px' }}
                          />
                        </a>
                      </>
                    )}
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  setTypeState(type: EquipmentImage) {
    this.rejectChanges();
    this.setState({ selected: type });
  }
  render() {
    return (
      <div className="card card-custom card-stretch">
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              EquipmentImages
            </h3>
            <span className="text-muted font-weight-bold font-size-sm mt-1">
              e.g. Custom, Loading , Shipment ...
            </span>
          </div>
          <div className="card-toolbar">
            <button
              type="submit"
              className="btn btn-success mr-2"
              onClick={this.addEquipmentImage}
              disabled={!this.state.allowAdd}
            >
              Add EquipmentImage
            </button>
            <button
              type="submit"
              className="btn btn-warning mr-2"
              onClick={() => {
                this.setState({ selected: null, allowAdd: true });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="card-body">
          {this.state.loading ? (
            <div className="row" style={{ minHeight: '200px' }}>
              <Loader
                size="large"
                style={{ position: 'relative', margin: '60px auto' }}
                type="converging-spinner"
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-xl-6">
                <div style={{ overflow: 'scroll', height: '600px' }}>
                  <Table className="table" bordered responsive="sm">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>File</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.equipmentImage?.map((type, idx) => {
                        return (
                          <tr
                            key={type.equipmentImageId}
                            style={{
                              backgroundColor:
                                type === this.state.selected
                                  ? 'lightgray'
                                  : 'white',
                            }}
                            onClick={() => this.setTypeState(type)}
                          >
                            <td>{type.imageName}</td>
                            <td>
                              {type.imageUrl && (
                                <img
                                  src={type.imageUrl}
                                  alt={type.imageName}
                                  style={{ maxHeight: '200px' }}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
              <div className="col-xl-6">
                {/* {this.state.selected && <AttachmentUpload handleFileChange={this.handleFileChange}/>} */}
                {this.renderPaymentEdit()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EquipmentImages;
